import { useMsal } from "@azure/msal-react";

import { useEffect, useState } from "react";
import { useLogin } from "../../../utils/authConfig";
import { getToken } from "../../../utils/authConfig";
import { listCommonCorpusFilesApi } from "../../../api";
import { useUseCase } from "../../../context/UseCaseContext/UseCaseContext";

// The shared corpus changes rarely: one request per use case and page load, shared by all mounts.
const corpusCache = new Map<string, Promise<string[]>>();

export const CorpusListDisplay = () => {
  const { selectedUseCase } = useUseCase();
  const displayName =
    selectedUseCase === "HR"
      ? "Guidelines in Knowledge Base"
      : "Documents in Knowledge Base";

  const client = useLogin ? useMsal().instance : undefined;
  const [result, setResult] = useState<string[]>(["Loading..."]);

  useEffect(() => {
    let cancelled = false;
    let request = corpusCache.get(selectedUseCase);
    if (!request) {
      request = (async () => {
        const token = client ? await getToken(client) : undefined;
        const response = await listCommonCorpusFilesApi(selectedUseCase, token);
        if (!response) throw Error("No response body");
        return response;
      })();
      corpusCache.set(selectedUseCase, request);
      // A failed request is retried the next time the list is shown.
      request.catch(() => corpusCache.delete(selectedUseCase));
    }
    setResult(["Loading..."]);
    request
      .then((files) => !cancelled && setResult(files))
      .catch(() => !cancelled && setResult(["Error on listing files. Try again later."]));
    return () => {
      cancelled = true;
    };
  }, [selectedUseCase, client]);

  return (
    <div>
      <h3>{displayName}</h3>
      {result.map((item, index) => (
        <p key={`${index}-${item}`}>{item}</p>
      ))}
    </div>
  );
};
